






























































































































































































































import {Component, Vue} from "vue-property-decorator";
import TaxEventDTO from "@/dto/tax/TaxEventDTO";
import TaxEventFilter, {TaxEventSortField} from "@/dto/tax/TaxEventFilter";
import TaxEventService from "@/services/TaxEventService";
import SimpleProfileSearch from "@/components/common/SimpleProfileSearch.vue";
import DictionarySelect from "@/components/common/DictionarySelect.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import SelectOption from "@/components/common/SelectOption";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import ProfileDTO from "@/dto/profile/ProfileDTO";
import moment from "moment";
import {processError} from "@/utils/ComponentUtils";
import { YEARS, Period } from "@/constants/DateTimeConstants";
import { TaxEventStatus } from "@/constants/TaxEventStatus";
import { PaymentStatus } from "@/constants/PaymentConstants";
import { Risk } from "@/constants/Risk";
import SublimeSearch from "@/components/common/SublimeSearch.vue";
import SublimeEmployeeDTO from "@/dto/sublime/employee/SublimeEmployeeDTO";
import CreateTaxEventModal from "@/components/admin/tax/CreateTaxEventModal.vue";

@Component({
  components: {
    SimpleProfileSearch,
    DictionarySelect,
    PortalInput,
    PortalSelect,
    PaginationComponent,
    CreateTaxEventModal,
    SublimeSearch
  }
})
export default class TaxCalendar extends Vue {

  private filter = new TaxEventFilter();
  private taxEvents: TaxEventDTO[] = [];
  private totalPages = 1;

  get yearOptions() {
    const list = YEARS.map(year => SelectOption.builder().title(`${year}`).value(year).build());
    return [SelectOption.builder().title("All").value(null).build(), ...list];
  }

  get periodOptions() {
    const list = Object.values(Period).map(period => SelectOption.builder().title(this.$stringUtils.enumToFormattedSentence(period)).value(period).build());
    return [SelectOption.builder().title("All").value(null).build(), ...list];
  }

  get statusOptions() {
    const list = Object.values(TaxEventStatus).map(val => SelectOption.builder().title(this.$stringUtils.enumToFormattedSentence(val)).value(val).build());
    return [SelectOption.builder().title("All").value(null).build(), ...list];
  }

  get paymentStatusOptions() {
    const list = Object.values(PaymentStatus).map(val => SelectOption.builder().title(this.$stringUtils.enumToFormattedSentence(val)).value(val).build());
    return [SelectOption.builder().title("All").value(null).build(), ...list];
  }

  get riskOptions() {
    const list = Object.values(Risk).map(val => SelectOption.builder().title(this.$stringUtils.enumToFormattedSentence(val)).value(val).build());
    return [SelectOption.builder().title("All").value(null).build(), ...list];
  }

  public mounted(): void {
    this.syncFilterFromQuery();
    this.loadPage();
  }

  private syncFilterFromQuery(): void {
    const q = this.$route.query;
    if (q.dateFrom) this.filter.dateFrom = q.dateFrom as string;
    if (q.dateTo) this.filter.dateTo = q.dateTo as string;
    if (q.taxTypeId) this.filter.taxTypeId = Number(q.taxTypeId);
    if (q.customerId) this.filter.customerId = Number(q.customerId);
    if (q.customerType) this.filter.customerType = q.customerType as any;
    if (q.pageNumber) this.filter.pageNumber = Number(q.pageNumber);
    if (q.sortBy) this.filter.sortBy = q.sortBy as any;
    if (q.sortDirection) this.filter.sortDirection = q.sortDirection as any;

    if (q.assigneeId) this.filter.assigneeId = Number(q.assigneeId);
    if (q.year) this.filter.year = Number(q.year);
    if (q.period) this.filter.period = q.period as any;
    if (q.status) this.filter.status = q.status as any;
    if (q.paymentStatus) this.filter.paymentStatus = q.paymentStatus as any;
    if (q.risk) this.filter.risk = q.risk as any;
  }

  private applyRouteParams(): void {
    const query: any = {};
    if (this.filter.dateFrom) query.dateFrom = this.filter.dateFrom;
    if (this.filter.dateTo) query.dateTo = this.filter.dateTo;
    if (this.filter.taxTypeId) query.taxTypeId = String(this.filter.taxTypeId);
    if (this.filter.customerId) query.customerId = String(this.filter.customerId);
    if (this.filter.customerType) query.customerType = this.filter.customerType;
    if (this.filter.pageNumber > 1) query.pageNumber = String(this.filter.pageNumber);
    if (this.filter.sortBy !== TaxEventSortField.CREATED_AT) query.sortBy = this.filter.sortBy;
    if (this.filter.sortDirection !== "DESC") query.sortDirection = this.filter.sortDirection;

    if (this.filter.assigneeId) query.assigneeId = String(this.filter.assigneeId);
    if (this.filter.year) query.year = String(this.filter.year);
    if (this.filter.period) query.period = this.filter.period;
    if (this.filter.status) query.status = this.filter.status;
    if (this.filter.paymentStatus) query.paymentStatus = this.filter.paymentStatus;
    if (this.filter.risk) query.risk = this.filter.risk;

    this.$router.replace({query}).catch(() => this.$void());
  }

  async handleSearch() {
    this.filter.pageNumber = 1;
    await this.loadPage();
  }

  async loadPage() {
    this.$loadOn();
    try {
      const response = await TaxEventService.getTaxEvents(this.filter)
      this.taxEvents = response.data.content;
      this.totalPages = response.data.totalPages;
      this.applyRouteParams();
    } catch (e) {
      processError(e, this)
    } finally {
      this.$loadOff();
    }
  }

  public changePage(page: number): void {
    this.filter.pageNumber = page;
    this.loadPage();
  }

  public clearFilter(): void {
    this.filter = new TaxEventFilter();
  }

  public onCustomerSelected(profile: ProfileDTO | null): void {
    if (profile) {
      this.filter.customerId = profile.id;
      this.filter.customerType = profile.type as any;
    } else {
      this.filter.customerId = null;
      this.filter.customerType = null;
    }
  }

  public onAssigneeSelected(employee: SublimeEmployeeDTO | null): void {
    if (employee) {
      this.filter.assigneeId = employee.id;
    } else {
      this.filter.assigneeId = null;
    }
  }

  public switchOrder(field: TaxEventSortField): void {
    if (this.filter.sortBy === field) {
      this.filter.sortDirection = this.filter.sortDirection === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.filter.sortBy = field;
      this.filter.sortDirection = 'ASC';
    }
    this.loadPage();
  }

  public getSortIcon(field: TaxEventSortField): string {
    if (this.filter.sortBy !== field) {
      return "sort";
    }
    return this.filter.sortDirection === 'ASC' ? "sort-up" : "sort-down";
  }

  public formatAmount(cents: number): string {
    return '$' + (cents / 100).toFixed(2);
  }

  goToEvent(id: number) {
    this.$router.push({ name: 'tax_event', params: { id: id.toString() } });
  }

  public formatDate(iso: string): string {
    if (!iso) return '';
    try {
      return moment(iso).format('MM/DD/YYYY HH:mm');
    } catch {
      return iso;
    }
  }
}
